export const SINGLE_LINE_TEXT = "single-line-text";
export const PLAIN_TEXT = "plain-text";
export const RICH_TEXT = "rich-text";
